{
  "form": {
    "fields": {
      "name": "Nome",
      "confirm_name": "Confirmar nome",
      "confirm_email": "Confirmar e-mail",
      "username": "Usuário",
      "email": "E-mail",
      "password": "Senha",
      "host": "Host",
      "format": "Formato",
      "beta": "Beta",
      "enabled": "Habilitado",
      "port": "Porta",
      "description": "Descrição",
      "id": "ID",
      "uuid": "UUID",
      "identifier": "Identificador",
      "author": "Autor",
      "ip": "IP",
      "alias": "Apelido",
      "ports": "Portas",
      "phpmyadmin_url": "URL phpMyAdmin",
      "name_first": "Primeiro Nome",
      "name_last": "Sobrenome",
      "preferences": {
        "language": "Idioma",
        "navbar_position": "Posição da barra de navegação"
      },
      "new_email": "Novo endereço de email",
      "current_password": "Senha atual",
      "new_password": "Nova senha",
      "new_password_confirmation": "Confirme a nova senha",
      "root_admin": "Administrador",
      "support_op": "Suporte OP",
      "support_op_bypass": "Suporte OP Bypass",
      "external_id": "ID Externo",
      "token": "Token",
      "memo": "Memo",
      "allowed_ips": "Conexão de IPS permitidos",
      "connection_address": "Endereço de conexão",
      "connections_from": "Conexões de",
      "folder_name": "Nome da pasta",
      "file_name": "Nome do Arquivo",
      "edition": "Edição",
      "version": "Versão",
      "repository": "URL do Repositório",
      "branch": "Branch",
      "access_token": "Token de Acesso Pessoal",
      "workshop_url": "URL da Oficina",
      "show_non_high_severity": "Mostrar resultados não filtrados",
      "time_offset": "Atraso de execução",
      "cron_minute": "Minuto",
      "cron_hour": "Hora",
      "cron_day_of_week": "Dia da Semana",
      "cron_day_of_month": "Dia do mês",
      "action": "Ação",
      "payload": "Comando",
      "panel_url": "URL do painel",
      "application_api_key": "Chave API do aplicativo",
      "users": "Usuários",
      "content": "Conteúdo",
      "type": "Tipo",
      "fqdn": "FQDN",
      "display_fqdn": "FQDN Exibido",
      "maintenance_mode": "Modo de manutenção",
      "location": "Localização",
      "egg": "Egg",
      "nest": "Nest",
      "docker_image": "Imagem do Docker",
      "startup": "Comando de inicialização",
      "cpu": "CPU",
      "memory": "Memória",
      "swap": "Swap",
      "disk": "Disco",
      "block_io_proportion": "Proporção do bloco IO",
      "overallocate": "Superalocação",
      "database_limit": "Limite da Database",
      "allocation_limit": "Limite de Alocação",
      "backup_megabytes_limit": "Tamanho máximo do backup",
      "category": "Categoria",
      "script_install": "Instalar script",
      "script_uninstall": "Desinstalar script",
      "config_from": "Copiar configurações de",
      "config_logs": "Configuração do log",
      "config_startup": "Configuração de Inicialização",
      "custom_config": "Configuração Personalizada",
      "config_files": "Arquivos de Configuração",
      "stop_command": "Comando de Parar",
      "copy_script_from": "Copiar Script de",
      "script_container": "Script de Contêiner",
      "script_entry": "Script Entrypoint",
      "env_variable": "Variáveis de Ambiente",
      "default_value": "Valor Padrão",
      "tickable": "Marcável",
      "user_viewable": "Visualizável pelo usuário",
      "user_editable": "Editável pelo usuário",
      "rules": "Regras",
      "allocation": "Alocação",
      "primary_allocation": "Alocação Primária",
      "secondary_allocations": "Alocações secundárias",
      "add_allocations": "Adicionar Alocações adicionais",
      "remove_allocations": "Remover Alocações adicionais",
      "server_owner": "Proprietário do Servidor",
      "startup_command": "Comando de inicialização",
      "default_startup_command": "Comando de inicialização padrão",
      "node": "Node",
      "backup": "Backup",
      "force": "Forçar",
      "start_on_completion": "Iniciar o servidor quando instalado",
      "skip_scripts": "Pular script de instalação",
      "oom_disabled": "Desabilitar OOM Killer",
      "domain_name": "Nome do domínio",
      "nest_identifiers": "Identificadores de Nest",
      "egg_identifiers": "Identificadores de Eggs",
      "root_record": "Registro Root",
      "invalidate_sessions": "Sessões inválidas",
      "branding": {
        "name": "Nome da Empresa"
      },
      "misc": {
        "databases_allow_random": "Permitir a implantação de Databases em Nodes aleatórios",
        "required_2fa": "Exigir autenticação de dois fatores"
      },
      "default_locale": "Idioma padrão",
      "og": {
        "site_name": "Nome do Site",
        "title": "Título",
        "description": "Descrição",
        "color": "Cores",
        "image": "URL da Imagem"
      },
      "whmcs": {
        "enabled": "WHMCS SSO Activado",
        "button_text": "Texto do Botão de Login",
        "url": "URL WHMCS",
        "client_id": "ID do Cliente WHMCS",
        "client_secret": "Client Secret WHMCS",
        "api_id": "ID da API WHMCS",
        "api_secret": "WHMCS API Secret"
      },
      "variable_value": "Variável {env}"
    },
    "validation_error": "Há o seguinte erro: | Existem os seguintes erros:",
    "validator": {
      "accepted": "O valor deve ser aceito | O campo {attribute} deve ser aceito",
      "active_url": "O valor não é um URL válido | O campo {attribute} não é um URL válido",
      "after": "O valor deve ser uma data depois de {date} . O campo {attribute} deve ser uma data depois de {date}",
      "after_or_equal": "O valor deve ser uma data depois de {date} . O campo {attribute} deve ser uma data depois de {date}",
      "alpha": "O valor só pode conter letras | O campo {attribute} só pode conter letras",
      "alpha_dash": "O valor só pode conter letras, números e traços | O campo {attribute} só pode conter letras, números e traços",
      "alpha_num": "O valor só pode conter letras, números | O campo {attribute} só pode conter letras e números",
      "array": "O valor deve ser um array | O campo {attribute} deve ser um array",
      "before": "O valor deve ser uma data antes de {date} | O campo {attribute} deve ser uma data antes de {date}",
      "before_or_equal": "O valor deve ser uma data anterior ou igual a {date} | O campo {attribute} deve ser uma data anterior ou igual a {date}",
      "between": {
        "numeric": "O valor deve estar entre {min} e {max} | O campo {attribute} deve estar entre {min} e {max}",
        "file": "O valor deve estar entre {min} e {max} kilobytes | O campo {attribute} deve estar entre {min} e {max} kilobytes",
        "string": "O valor deve estar entre {min} e {max} caracteres | O campo {attribute} deve estar entre {min} e {max} caracteres",
        "array": "O valor deve estar entre {min} e {max} itens | O campo {attribute} deve estar entre {min} e {max} itens"
      },
      "boolean": "O valor deve ser verdadeiro ou falso | O campo {attribute} deve ser verdadeiro ou falso",
      "confirmed": "A confirmação do valor não corresponde | A confirmação de campo {attribute} não corresponde",
      "date": "O valor não é uma data válida | O campo {attribute} não é uma data válida",
      "date_format": "O valor não corresponde ao formato {format} | O campo {attribute} não corresponde ao formato {format}",
      "different": "O valor e {other} devem diferir | O campo {attribute} e {other} devem diferir",
      "digits": "O valor deve ser {digits} dígitos | O campo {attribute} deve ser {digits} dígitos",
      "digits_between": "O valor deve estar entre os dígitos {min} e {max} | O campo {attribute} deve estar entre os dígitos {min} e {max}",
      "dimensions": "O valor tem dimensões de imagem inválidas | O campo {attribute} tem dimensões de imagem inválidas",
      "distinct": "O valor tem um valor duplicado | O campo {attribute} tem um valor duplicado",
      "email": "O valor deve ser um email válido | O campo {attribute} deve ser um email válido",
      "exists": "O valor é inválido | O campo {attribute} é inválido",
      "file": "O valor deve ser um arquivo | O campo {attribute} deve ser um arquivo",
      "filled": "O valor é inválido | O campo {attribute} é inválido",
      "image": "O valor deve ser uma imagem | O campo {attribute} deve ser uma imagem",
      "in": "O valor é inválido | O campo {attribute} é inválido",
      "in_array": "O valor não existe em {other} | O campo {attribute} não existe em {other}",
      "integer": "O valor deve ser um número inteiro válido | O campo {attribute} deve ser um número inteiro.",
      "ip": "O valor deve ser um endereço IP válido | O campo {attribute} deve ser um endereço IP válido",
      "json": "O valor deve ser uma string JSON válida | O campo {attribute} deve ser uma string JSON válida",
      "max": {
        "numeric": "O valor não pode ser superior a {max} | O campo {attribute} não pode ser superior a {max}",
        "file": "O valor não pode ser superior a {max} kilobytes | O campo {attribute} não pode ser superior a {max} kilobytes",
        "string": "O valor não pode ser superior a {max} caracteres | O campo {attribute} não pode ser superior a {max} caracteres",
        "array": "O valor não pode ser superior a {max} itens | O campo {attribute} não pode ser superior a {max} itens"
      },
      "mimes": "O valor deve ser um arquivo do tipo: {values} | O campo {attribute} deve ser um arquivo do tipo: {values}",
      "mimetypes": "O valor deve ser um arquivo do tipo: {values} | O campo {attribute} deve ser um arquivo do tipo: {values}",
      "min": {
        "numeric": "O valor deve ser pelo menos {min} | O campo {attribute} deve ser pelo menos {min}",
        "file": "O valor deve ser pelo menos {min} kilobytes | O campo {attribute} deve ser pelo menos {min} kilobytes",
        "string": "O valor deve ser de pelo menos {min} caracteres | O campo {attribute} deve ser de pelo menos {min} caracteres",
        "array": "O valor deve ser pelo menos {min} itens | O campo {attribute} deve ser pelo menos {min} itens"
      },
      "not_in": "O valor é inválido | O campo {attribute} é inválido",
      "numeric": "O valor deve ser um número | O campo {attribute} deve ser um número",
      "present": "O valor deve estar presente | O campo {attribute} deve estar presente",
      "regex": "O valor é inválido | O campo {attribute} é inválido",
      "required": "O campo é obrigatório | O campo {attribute} é obrigatório",
      "required_if": "O valor é requerido quando {other} é {value} | O campo {attribute} é requerido quando {other} é {value}",
      "required_unless": "O valor é obrigatório a menos que {other} esteja em {values} | O campo {attribute} é obrigatório a menos que {other} esteja em {values}",
      "required_with": "O valor é requerido quando {values} está presente | O campo {attribute} é requerido quando {values} está presente",
      "required_with_all": "O valor é requerido quando {values} está presente | O campo {attribute} é requerido quando {values} está presente",
      "required_without": "O valor é requerido quando {values} não está presente | O campo {attribute} é requerido quando {values} não está presente",
      "required_without_all": "O valor é requerido quando nenhum de {values} está presente | O campo {attribute} é requerido quando nenhum de {values} está presente",
      "same": "O valor e {other} devem corresponder | O campo {attribute} e {other} devem corresponder",
      "size": {
        "numeric": "O valor deve ser {size} | O campo {attribute} deve ser {size}",
        "file": "O valor deve ser {size} kilobytes | O campo {attribute} deve ser {size} kilobytes",
        "string": "O valor deve ser {size} caracteres | O campo {attribute} deve ser {size} caracteres",
        "array": "O valor deve ser {size} itens | O campo {attribute} deve ser {size} itens"
      },
      "string": "O valor deve ser uma cadeia | O campo {attribute} deve ser uma cadeia",
      "timezone": "O valor deve ser uma zona válida | O campo {attribute} deve ser uma zona válida",
      "unique": "O valor já foi tomado | O campo {attribute} já foi tomado",
      "uploaded": "O valor falhou em salvar | O campo {attribute} falhou em salvar",
      "url": "O valor é inválido | O campo {attribute} é inválido"
    }
  },
  "table": {
    "labels": {
      "key": "Chave",
      "memo": "Memo",
      "last_used": "Usado pela última vez",
      "created": "Criado",
      "uuid": "UUID",
      "id": "ID",
      "email": "Email",
      "name": "Nome",
      "description": "Descrição",
      "owner": "Dono",
      "connection": "Conexão",
      "username": "Usuário",
      "password": "Senha",
      "2fa": "2FA",
      "downloads": "Downloads",
      "queued": "Na fila",
      "tasks": "Tarefas",
      "last_run": "Última execução",
      "next_run": "Próxima Execução",
      "file_name": "Nome do Arquivo",
      "size": "Tamanho",
      "created_at": "Criado em",
      "migrated_at": "Migrado em",
      "last_modified": "Última modificação",
      "allocation": "Alocação",
      "fqdn": "FQDN",
      "ip": "IP",
      "alias": "Apelido",
      "port": "Porta",
      "plan": "Plano",
      "domain": "Domínio",
      "licensed_to": "Licenciado para",
      "expires": "Expira",
      "addons": "Addons",
      "version": "Versão",
      "category": "Categoria",
      "active": "Ativo",
      "content": "Conteúdo",
      "host": "Host",
      "databases": "Databases",
      "node": "Node",
      "server": "Servidor\n",
      "connections_from": "Conexões de",
      "nodes": "Nodes",
      "servers": "Servidores",
      "eggs": "Eggs",
      "location": "Localização",
      "cpu": "CPU",
      "memory": "Memória",
      "disk": "Disco",
      "assigned_to": "Atribuído à",
      "internal_identifier": "Identificador interno",
      "external_identifier": "Identificador externo",
      "service": "Serviço",
      "block_io_weight": "Peso do Bloco IO",
      "backup_size_limit": "Limite do tamanho do backup",
      "default_connection": "Conexão padrão",
      "connection_alias": "Apelido da Conexão",
      "domain_name": "Nome do domínio"
    }
  }
}
